// export const HANDLE_RESPONSIVE = "LOAD_USER_SUCCESS"
export const LOGOUT = "LOGOUT"
